var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecondIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10935_3259)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 4.66667C5.71134 4.66667 4.66667 5.71134 4.66667 7C4.66667 8.28866 5.71134 9.33333 7 9.33333C8.28866 9.33333 9.33333 8.28866 9.33333 7C9.33333 5.71134 8.28866 4.66667 7 4.66667ZM3.5 7C3.5 5.067 5.067 3.5 7 3.5C8.933 3.5 10.5 5.067 10.5 7C10.5 8.933 8.933 10.5 7 10.5C5.067 10.5 3.5 8.933 3.5 7Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0C7.32217 0 7.58333 0.261167 7.58333 0.583333V1.75C7.58333 2.07217 7.32217 2.33333 7 2.33333C6.67783 2.33333 6.41667 2.07217 6.41667 1.75V0.583333C6.41667 0.261167 6.67783 0 7 0Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 11.6667C7.32217 11.6667 7.58333 11.9278 7.58333 12.25V13.4167C7.58333 13.7388 7.32217 14 7 14C6.67783 14 6.41667 13.7388 6.41667 13.4167V12.25C6.41667 11.9278 6.67783 11.6667 7 11.6667Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.04919 2.04919C2.27699 1.82138 2.64634 1.82138 2.87415 2.04919L3.70248 2.87752C3.93028 3.10533 3.93028 3.47467 3.70248 3.70248C3.47467 3.93028 3.10533 3.93028 2.87752 3.70248L2.04919 2.87415C1.82138 2.64634 1.82138 2.27699 2.04919 2.04919Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2975 10.2975C10.5253 10.0697 10.8947 10.0697 11.1225 10.2975L11.9508 11.1259C12.1786 11.3537 12.1786 11.723 11.9508 11.9508C11.723 12.1786 11.3537 12.1786 11.1259 11.9508L10.2975 11.1225C10.0697 10.8947 10.0697 10.5253 10.2975 10.2975Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7C0 6.67783 0.261167 6.41667 0.583333 6.41667H1.75C2.07217 6.41667 2.33333 6.67783 2.33333 7C2.33333 7.32217 2.07217 7.58333 1.75 7.58333H0.583333C0.261167 7.58333 0 7.32217 0 7Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6667 7C11.6667 6.67783 11.9278 6.41667 12.25 6.41667H13.4167C13.7388 6.41667 14 6.67783 14 7C14 7.32217 13.7388 7.58333 13.4167 7.58333H12.25C11.9278 7.58333 11.6667 7.32217 11.6667 7Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.70248 10.2975C3.93028 10.5253 3.93028 10.8947 3.70248 11.1225L2.87415 11.9508C2.64634 12.1786 2.27699 12.1786 2.04919 11.9508C1.82138 11.723 1.82138 11.3537 2.04919 11.1259L2.87752 10.2975C3.10533 10.0697 3.47467 10.0697 3.70248 10.2975Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9511 2.04878C12.1789 2.27659 12.1789 2.64594 11.9511 2.87374L11.1228 3.70208C10.895 3.92988 10.5256 3.92988 10.2978 3.70208C10.07 3.47427 10.07 3.10492 10.2978 2.87712L11.1261 2.04878C11.3539 1.82098 11.7233 1.82098 11.9511 2.04878Z",
    fill: "#4D4D4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10935_3259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondIcon);
export default __webpack_public_path__ + "static/media/second-icon.53a1f162fbcc657addb53af483b072c3.svg";
export { ForwardRef as ReactComponent };